/* src/app/features/tarefas/protocolo/tarefas-protocolo.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 853px;
  font-weight: bold;
}
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
/*# sourceMappingURL=tarefas-protocolo.component.css.map */
